<template>
    <div class="view view-practice-phonemic-consonant">
        <HeaderPractice
            headerText="Ünsüz Özellikleri"
            @leavePractice="leavePractice" />
        <ProgressbarPractice
            :indicatorPercent="indicatorPercent" />
        <NotificationPerfectionProgress
            v-show="showNotificationPerfectionProgress" />
        <NotificationPerfectionReset
            v-show="showNotificationPerfectionReset" />
        <NotificationPerfectionAchievement
            v-show="showNotificationPerfectionAchievement"
            :valuePhone="`/ ${currentQuestion.questionObject.valuePhonemic} /`"
            @emitClaim="hideNotificationPerfectionAchievement" />
        <div class="wr-question-object">
            <QuestionObjectPhonemicConsonant
                :phonemicValue="currentQuestion.questionObject.valuePhonemic" />
            <BtnVocalize
                @click="vocalize" />
        </div>

        <p class="question-desc">Üç boyutluluk özelliklerini işaretle.</p>
        
        <div
            v-if="feedbackPhase === false"
            class="wr-optionboard">
            <ScoreboardPhonemicConsonant
                :scorelist="scorelist" />
            <OptionboardPhonemicConsonant
                :placeOptions="placeOptions"
                :mannerOptions="mannerOptions" />
        </div>

        <div
            v-if="feedbackPhase === true"
            class="wr-feedbackboard">
            <ScoreboardPhonemicConsonant
                :scorelist="scorelist" />
            <FeedbackboardPhonemicConsonant />
        </div>

        <BtnAnswerCheck
            v-if="feedbackPhase === false"
            @click="this.$store.state.envDev ? checkAnswer() : checkAnswerApi()" />

        <BtnAnswerSkip
            v-if="feedbackPhase === false"
            @click="this.$store.state.envDev ? skipAnswer() : skipAnswerApi()" />

        <Feedbackbar
            v-if="feedbackPhase === true"
            :correctness="correctness" />

        <BtnQuestionNext
            v-if="feedbackPhase === true"
            :correctness="correctness"
            @click="this.$store.state.envDev ? nextQuestion() : nextQuestionApi()" />
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import FakeApi                          from '@/libs/FakeApi.js';
    import OptionGenerator                  from '@/libs/OptionGenerator.js';
    import { animate, createTimeline }  from 'animejs';
    import confetti from "@hiseb/confetti";

    import HeaderPractice                   from '@/components/HeaderPractice.vue';
    import ProgressbarPractice              from '@/components/ProgressbarPractice.vue';
    import QuestionObjectPhonemicConsonant  from '@/components/QuestionObjectPhonemicConsonant.vue';
    import NotificationPerfectionProgress   from '@/components/NotificationPerfectionProgress.vue';
    import NotificationPerfectionReset      from '@/components/NotificationPerfectionReset.vue';
    import NotificationPerfectionAchievement from '@/components/NotificationPerfectionAchievement.vue';
    import BtnVocalize                      from '@/components/BtnVocalize.vue';
    import ScoreboardPhonemicConsonant      from '@/components/ScoreboardPhonemicConsonant.vue';
    import OptionboardPhonemicConsonant     from '@/components/OptionboardPhonemicConsonant.vue';
    import FeedbackboardPhonemicConsonant   from '@/components/FeedbackboardPhonemicConsonant.vue';
    import BtnAnswerCheck                   from '@/components/BtnAnswerCheck.vue';
    import BtnAnswerSkip                    from '@/components/BtnAnswerSkip.vue';
    import Feedbackbar                      from '@/components/Feedbackbar.vue';
    import BtnQuestionNext                  from '@/components/BtnQuestionNext.vue';


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        components: {
            HeaderPractice,
            ProgressbarPractice,
            NotificationPerfectionProgress,
            NotificationPerfectionReset,
            NotificationPerfectionAchievement,
            QuestionObjectPhonemicConsonant,
            BtnVocalize,
            ScoreboardPhonemicConsonant,
            OptionboardPhonemicConsonant,
            FeedbackboardPhonemicConsonant,
            BtnAnswerCheck,
            BtnAnswerSkip,
            Feedbackbar,
            BtnQuestionNext,
        },

        data(){
            return {
                numAnswered:    0,
                feedbackPhase:  false,
                scorelist:      [-1, -1, -1],
                placeOptions:   [],
                mannerOptions:  [],
                correctness:    null,
                allowRequest:   true,
                allowClaim: false,
                showNotificationPerfectionProgress: false,
                showNotificationPerfectionReset: false,
                showNotificationPerfectionAchievement: false,
                animations: {
                    perfectionProgress: {
                        tl1: null,
                        plus1: null,
                        plus2: null,
                        direction: null,
                    },
                    perfectionReset: {
                        tl1: null,
                        x1: null,
                        x2: null,
                        direction: null,
                    },
                    perfectionAchievement: {
                        tlMain: null,
                        tlSmallDiamonds: null,
                        tlSmallDiamonds2: null,
                        tlAchievementDiamondRotate: null,
                    },
                    perfectionConfetti: {
                        allow: true,
                    },
                },
            };
        },

        computed: {
            indicatorPercent(){
                let numQuestions   = this.$store.state.questionSet.length;
                return (this.numAnswered / numQuestions) * 100;
            },

            currentQuestion(){
                let idxCurQuestion = this.$store.state.practiceSession.idxCurQuestion;
                return this.$store.state.questionSet[idxCurQuestion];
            },

            vocalizationSlug(){
                // Get current question.
                let idxCurQuestion = this.$store.state.practiceSession.idxCurQuestion;
                let curQuestion = this.$store.state.questionSet[idxCurQuestion];

                // Get current question's phonemic value.
                let curPhonemicValue = curQuestion.questionObject.valuePhonemic.toUpperCase();

                // Set vocalization slug to be used when accessing vuex prop.
                let vocalizationSlug = 'phonemicConsonant' + curPhonemicValue;
                return vocalizationSlug;
            },
        },

        methods: {
            vocalize(){
                // Play vocalization audio.
                this.$store.state.sfx[this.vocalizationSlug].currentTime = 0;
                this.$store.state.sfx[this.vocalizationSlug].play();
            },

            setAnimationsNotificationPerfectionProgress(){
                this.animations.perfectionProgress.tl1 = createTimeline({autoplay: false})
                .add('.notification-perfection-progress', {
                    height: {
                        from: '0px',
                        to: '50px',
                    },
                    ease: 'inOutExpo',
                })
                .add('.notification-perfection-progress', {
                    height: {
                        from: '50px',
                        to: '0px',
                    },
                    ease: 'inOutExpo',
                    delay: 3000,
                    onComplete: () => {
                        this.showNotificationPerfectionProgress = false;
                        this.animations.perfectionProgress.plus1.revert();
                        this.animations.perfectionProgress.plus2.revert();
                        this.animations.perfectionProgress.direction.revert();
                    }
                });

                this.animations.perfectionProgress.plus1 = animate(document.querySelector('.notification-perfection-progress__art-perfection-plus:nth-child(4)'), {
                    translateY: "-25px",
                    opacity: 0,
                    loop: true,
                    duration: 1250,
                    autoplay: false,
                });

                this.animations.perfectionProgress.plus2 = animate(document.querySelector('.notification-perfection-progress__art-perfection-plus:nth-child(5)'), {
                    translateY: "-30px",
                    opacity: 0,
                    loop: true,
                    duration: 1250,
                    delay: 500,
                    ease: 'out',
                    autoplay: false,
                });

                this.animations.perfectionProgress.direction = animate('.notification-perfection-progress__art-direction', {
                    x: '34px',
                    duration: 1000,
                    loop: true,
                    ease: 'in',
                    autoplay: false,
                });
            },

            runAnimationsNotificationPerfectionProgress(){
                this.animations.perfectionProgress.tl1.revert();
                this.animations.perfectionProgress.plus1.revert();
                this.animations.perfectionProgress.plus2.revert();
                this.animations.perfectionProgress.direction.revert();

                this.animations.perfectionProgress.tl1.play();
                this.animations.perfectionProgress.plus1.play();
                this.animations.perfectionProgress.plus2.play();
                this.animations.perfectionProgress.direction.play();
            },

            revertAnimationsNotificationPerfectionProgress(){
                this.animations.perfectionProgress.tl1.revert();
                this.animations.perfectionProgress.plus1.revert();
                this.animations.perfectionProgress.plus2.revert();
                this.animations.perfectionProgress.direction.revert();
            },

            setAnimationsNotificationPerfectionReset(){
                this.animations.perfectionReset.tl1 = createTimeline({autoplay: false})
                .add('.notification-perfection-reset', {
                    height: {
                        from: '0px',
                        to: '50px',
                    },
                    ease: 'inOutExpo',
                })
                .add('.notification-perfection-reset', {
                    height: {
                        from: '50px',
                        to: '0px',
                    },
                    ease: 'inOutExpo',
                    delay: 3000,
                    onComplete: () => {
                        this.showNotificationPerfectionReset = false;
                        this.animations.perfectionReset.x1.revert();
                        this.animations.perfectionReset.x2.revert();
                        this.animations.perfectionReset.direction.revert();
                    }
                });

                this.animations.perfectionReset.x1 = animate(document.querySelector('.notification-perfection-reset__art-perfection-x:nth-child(4)'), {
                    translateY: "-30px",
                    opacity: 0,
                    loop: true,
                    duration: 1250,
                    delay: 500,
                    ease: 'out',
                    autoplay: false,
                });

                this.animations.perfectionReset.x2 = animate(document.querySelector('.notification-perfection-reset__art-perfection-x:nth-child(5)'), {
                    translateY: "-25px",
                    opacity: 0,
                    loop: true,
                    duration: 1250,
                    autoplay: false,
                });

                this.animations.perfectionReset.direction = animate(document.querySelector('.notification-perfection-reset-data__art-direction'), {
                    x: '-34px',
                    duration: 1000,
                    loop: true,
                    ease: 'in',
                    autoplay: false,
                });

            },

            runAnimationsNotificationPerfectionReset(){
                this.animations.perfectionReset.tl1.revert();
                this.animations.perfectionReset.x1.revert();
                this.animations.perfectionReset.x2.revert();
                this.animations.perfectionReset.direction.revert();

                this.animations.perfectionReset.tl1.play();
                this.animations.perfectionReset.x1.play();
                this.animations.perfectionReset.x2.play();
                this.animations.perfectionReset.direction.play();
            },

            revertAnimationsNotificationPerfectionReset(){
                this.animations.perfectionReset.tl1.revert();
                this.animations.perfectionReset.x1.revert();
                this.animations.perfectionReset.x2.revert();
                this.animations.perfectionReset.direction.revert();
            },

            setAnimationsNotificationPerfectionAchievement(){
                let sfxSwoosh = this.$store.state.sfx.swoosh;
                let sfxAchievement = this.$store.state.sfx.ach;
                sfxAchievement.addEventListener('timeupdate', (e) => {
                    if(sfxAchievement.currentTime >= 4.5 && this.animations.perfectionConfetti.allow){
                        this.runAnimationsConfetti();
                        document.querySelector('.notification-perfection-achievement').classList.remove('notification-perfection-achievement--disallow-claim')
                        this.allowClaim = true;
                    }
                })
                this.animations.perfectionAchievement.tlSmallDiamonds = createTimeline({
                    autoplay: false,
                })
                .add('.notification-perfection-achievement__art-small-diamond--left1', {
                    translateX: '166px',
                    duration: 1000,
                    ease: 'inOutExpo',
                    onBegin: () => {setTimeout(() => {sfxSwoosh.currentTime = 0; sfxSwoosh.play()}, 300)}
                })
                .add('.notification-perfection-achievement__art-small-diamond--right1', {
                    translateX: '-166px',
                    duration: 1000,
                    ease: 'inOutExpo',
                    onBegin: () => {setTimeout(() => {sfxSwoosh.currentTime = 0; sfxSwoosh.play()}, 300)},
                })

                .add('.notification-perfection-achievement__art-small-diamond--left2', {
                    translateX: '166px',
                    duration: 750,
                    ease: 'inOutExpo',
                    onBegin: () => {setTimeout(() => {sfxSwoosh.currentTime = 0; sfxSwoosh.play()}, 300)},
                })
                .add('.notification-perfection-achievement__art-small-diamond--right2', {
                    translateX: '-166px',
                    duration: 750,
                    ease: 'inOutExpo',
                    onBegin: () => {setTimeout(() => {sfxSwoosh.currentTime = 0; sfxSwoosh.play()}, 300)},
                })

                .add('.notification-perfection-achievement__art-small-diamond--left3', {
                    translateX: '166px',
                    duration: 500,
                    ease: 'inOutExpo',
                    onBegin: () => {setTimeout(() => {sfxSwoosh.currentTime = 0; sfxSwoosh.play()}, 300)},
                })
                .add('.notification-perfection-achievement__art-small-diamond--right3', {
                    translateX: '-166px',
                    duration: 500,
                    ease: 'inOutExpo',
                    onBegin: () => {setTimeout(() => {sfxSwoosh.currentTime = 0; sfxSwoosh.play()}, 300)},
                })

                .add('.notification-perfection-achievement__art-small-diamond--left4', {
                    translateX: '166px',
                    duration: 250,
                    ease: 'inOutExpo',
                    onBegin: () => {setTimeout(() => {sfxSwoosh.currentTime = 0; sfxSwoosh.play()}, 300)},
                })
                .add('.notification-perfection-achievement__art-small-diamond--right4', {
                    translateX: '-166px',
                    duration: 250,
                    ease: 'inOutExpo',
                    onBegin: () => {setTimeout(() => {sfxSwoosh.currentTime = 0; sfxSwoosh.play()}, 300)},
                });

                this.animations.perfectionAchievement.tlSmallDiamonds2 = createTimeline({
                    autoplay: false,
                    onComplete: () => {sfxAchievement.currentTime = 0; sfxAchievement.play()}
                })
                .add('.notification-perfection-achievement__art-small-diamond--left5', {
                    translateX: '166px',
                    duration: 250,
                    ease: 'inOutExpo',
                    onBegin: () => {setTimeout(() => {sfxSwoosh.currentTime = 0; sfxSwoosh.play()}, 300)},
                })
                .add('.notification-perfection-achievement__art-small-diamond--right5', {
                    translateX: '-166px',
                    duration: 250,
                    ease: 'inOutExpo',
                    onBegin: () => {setTimeout(() => {sfxSwoosh.currentTime = 0; sfxSwoosh.play()}, 300)},
                });

                this.animations.perfectionAchievement.tlAchievementDiamondRotate = createTimeline({
                    autoplay: false,
                })
                .add('.notification-perfection-achievement__art-achievement-diamond', {
                    rotate: '15deg',
                    duration: 1000,
                    ease: 'inOutExpo'
                })
                .add('.notification-perfection-achievement__art-achievement-diamond', {
                    rotate: '-15deg',
                    duration: 1000,
                    ease: 'inOutExpo'
                })

                .add('.notification-perfection-achievement__art-achievement-diamond', {
                    rotate: '15deg',
                    duration: 750,
                    ease: 'inOutExpo'
                })
                .add('.notification-perfection-achievement__art-achievement-diamond', {
                    rotate: '-15deg',
                    duration: 750,
                    ease: 'inOutExpo'
                })

                .add('.notification-perfection-achievement__art-achievement-diamond', {
                    rotate: '15deg',
                    duration: 500,
                    ease: 'inOutExpo'
                })
                .add('.notification-perfection-achievement__art-achievement-diamond', {
                    rotate: '-15deg',
                    duration: 500,
                    ease: 'inOutExpo'
                })

                .add('.notification-perfection-achievement__art-achievement-diamond', {
                    rotate: '15deg',
                    duration: 250,
                    ease: 'inOutExpo'
                })
                .add('.notification-perfection-achievement__art-achievement-diamond', {
                    rotate: '-15deg',
                    duration: 250,
                    ease: 'inOutExpo'
                })
                .add('.notification-perfection-achievement__art-achievement-diamond', {
                    rotate: '0deg',
                    duration: 250,
                    ease: 'inOutExpo'
                });

                this.animations.perfectionAchievement.tlMain = createTimeline({
                    autoplay: false,
                    onComplete(){
                        document.querySelector('.notification-perfection-achievement__art-achievement-diamond').classList.add('notification-perfection-achievement--shake-diamond');
                        document.querySelector('.notification-perfection-achievement-btn-claim').style.display = "flex";
                        animate('.notification-perfection-achievement__heading', {
                            opacity: 1,
                        });
                        animate('.notification-perfection-achievement__text', {
                            opacity: 1,
                        });
                        animate('.notification-perfection-achievement-btn-claim', {
                            opacity: 1,
                            delay: 500,
                        });
                    }
                })
                .sync(this.animations.perfectionAchievement.tlSmallDiamonds)
                .sync(this.animations.perfectionAchievement.tlSmallDiamonds2)
                .sync(this.animations.perfectionAchievement.tlAchievementDiamondRotate, 0);
            },

            runAnimationsNotificationPerfectionAchievement(){
                this.$store.state.sfx.ach.pause();
                this.$store.state.sfx.ach.currentTime = 0;
                this.animations.perfectionConfetti.allow = true;
                this.animations.perfectionAchievement.tlMain.revert();
                this.animations.perfectionAchievement.tlMain.play();
            },

            revertAnimationsNotificationPerfectionAchievement(){
                this.animations.perfectionAchievement.tlMain.revert();
            },

            hideNotificationPerfectionAchievement(){
                if(this.allowClaim === false){
                    return;
                }
                this.showNotificationPerfectionAchievement = false;
                this.revertAnimationsNotificationPerfectionAchievement();
                document.querySelector('.notification-perfection-achievement__art-achievement-diamond').classList.remove('notification-perfection-achievement--shake-diamond');
                document.querySelector('.notification-perfection-achievement-btn-claim').style.display = "none";
                document.querySelector('.notification-perfection-achievement__heading').style.opacity = "0";
                document.querySelector('.notification-perfection-achievement__text').style.opacity = "0";
                document.querySelector('.notification-perfection-achievement-btn-claim').style.opacity = "0";
                document.querySelector('.notification-perfection-achievement').classList.add('notification-perfection-achievement--disallow-claim')
                this.allowClaim = false;
            },

            runAnimationsConfetti(){
                confetti({
                    position: {
                        x: 0,
                        y: 0,
                    },
                });
                confetti({
                    position: {
                        x: window.innerWidth,
                        y: 0,
                    },
                });
                confetti({
                    position: {
                        x: window.innerWidth / 2,
                        y: window.innerHeight / 2,
                    },
                });
                this.animations.perfectionConfetti.allow = false;
            },

            checkAnswer(){
                // Prevent answer checks if user hasn't chosen an option for each feature type.
                for(const [feature, answerValue] of Object.entries(this.$store.state.answerData.consonantFeatures)){

                    if(!answerValue){
                        this.$foneturkToast(this.$t('alert.answerCheckPrevention.phonemicConsonant'), 'DİKKAT');
                        return;
                    }
                }

                // Define temporary scorelist.
                let scorelist = [];

                // Define temporary feedback data to collect answer data.
                let feedbackData = {
                    place:   null,
                    manner:  null,
                    voicing: null
                };

                // Define initial feature correctness value.
                let featureCorrectness = 1;

                // Set initial question correctness value.
                this.correctness = 1;
                
                // Get current question consonant features.
                let curQuestionConsonantFeatures = this.currentQuestion.consonantFeatures;

                // Get answer data consonant features.
                let answerConsonantFeatures = this.$store.state.answerData.consonantFeatures;

                // Compare correct feature-value against answer feature-value.
                for(const [feature, correctValue] of Object.entries(curQuestionConsonantFeatures)){

                    // Reset feature correctness value on each comparison.
                    featureCorrectness = 1;

                    // Get currently iterated answer feature-value.
                    const answerValue = answerConsonantFeatures[feature];

                    if(correctValue !== answerValue){

                        // Disable feature correctness value.
                        featureCorrectness = 0;

                        // Update question correctness value.
                        this.correctness = 0;
                    }

                    // Update temporary scorelist data.
                    scorelist.push(featureCorrectness);

                    // Update temporary feedback data.
                    feedbackData[feature] = {
                        correctValue: correctValue,
                        answerValue:  answerValue
                    };
                }

                // Update scorelist data prop.
                this.scorelist = scorelist;

                // Update feedback data in vuex store.
                this.$store.commit('setFeedbackData', feedbackData);

                // Update practice stats in vuex store.
                if(this.correctness === 1){
                    this.$store.commit('incrementPracticeStatCorrect');
                }
                else if(this.correctness === 0){
                    this.$store.commit('incrementPracticeStatIncorrect');
                }
                else{
                    throw new Error('VIEW_PRACTICE_PHONEMIC_CONSONANT/CHECK_ANSWER/INV_CORRECTNESS_VALUE');
                }

                // Update the number of answered questions data prop.
                this.numAnswered++;

                // Show perfection notification.
                this.showNotificationPerfectionAchievement = true;
                this.runAnimationsNotificationPerfectionAchievement();
                // if(this.correctness === 1){
                //     if(this.showNotificationPerfectionReset){
                //         this.showNotificationPerfectionReset = false;
                //     }
                //     this.$store.commit('setPerfectionData', {
                //         type: 'progress',
                //         previous: 5,
                //         current: 10,
                //     });
                //     this.showNotificationPerfectionProgress = true;
                //     this.runAnimationsNotificationPerfectionProgress();
                // }
                // else if(this.correctness === 0){
                //     if(this.showNotificationPerfectionProgress){
                //         this.showNotificationPerfectionProgress = false;
                //     }
                //     this.$store.commit('setPerfectionData', {
                //         type: 'reset',
                //         previous: 15,
                //         current: 0,
                //     });
                //     this.showNotificationPerfectionReset = true;
                //     this.runAnimationsNotificationPerfectionReset();
                // }

                // Activate feedback phase.
                this.feedbackPhase = true;

                // Play SFX based on correctness.
                if(this.correctness === 1){
                    this.$store.state.sfx.correct.currentTime = 0;
                    this.$store.state.sfx.correct.play();
                }
                else if(this.correctness === 0){
                    this.$store.state.sfx.incorrect.currentTime = 0;
                    this.$store.state.sfx.incorrect.play();
                }
            },

            checkAnswerApi(){
                // Prevent answer checks if user hasn't chosen an option for each feature type.
                for(const [feature, answerValue] of Object.entries(this.$store.state.answerData.consonantFeatures)){

                    if(!answerValue){
                        this.$foneturkToast(this.$t('alert.answerCheckPrevention.phonemicConsonant'), 'DİKKAT');
                        return;
                    }
                }

                // Check request allowance.
                if(this.allowRequest === false){
                    console.warn("PHONEMIC_CONSONANT_VIEW/CHECK_ANSWER_API::REQUEST_NOT_ALLOWED");
                    return;
                }
                this.allowRequest = false;

                // Arrange request body answer data.
                let answerData = 'answerData=' + JSON.stringify(this.$store.state.answerData);

                // Prepare and send fetch request.
                fetch(this.$store.state.api.checkAnswer, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: answerData
                })
                .then(async response => {
                    // Check response status.
                    if(response.status !== 200){
                        throw await response.json();
                    }

                    // Parse response body $correctnessData.
                    return response.json();
                })
                .then(correctnessData => {
                    console.log(correctnessData);

                    // Update the number of answered questions.
                    this.numAnswered++;

                    // Update scorelist data.
                    this.scorelist = correctnessData.scorelist;

                    // Update feedback data.
                    this.$store.commit('setFeedbackData', correctnessData.feedbackData);

                    // Update perfection data.
                    this.$store.commit('setPerfectionData', correctnessData.perfectionData);

                    // Update question correctness data.
                    this.correctness = correctnessData.correctness;

                    // Activate feedback phase.
                    this.feedbackPhase = true;

                    // Play SFX based on correctness.
                    if(this.correctness === 1){
                        this.$store.state.sfx.correct.currentTime = 0;
                        this.$store.state.sfx.correct.play();
                    }
                    else if(this.correctness === 0){
                        this.$store.state.sfx.incorrect.currentTime = 0;
                        this.$store.state.sfx.incorrect.play();
                    }

                    // Show perfection notification if there is one.
                    if(this.$store.state.perfectionData != null){
                        if(this.$store.state.perfectionData.type === 'progress'){
                            if(this.showNotificationPerfectionReset){
                                this.showNotificationPerfectionReset = false;
                            }
                            this.showNotificationPerfectionProgress = true;
                            this.runAnimationsNotificationPerfectionProgress();
                        }
                        else if(this.$store.state.perfectionData.type === 'reset'){
                            if(this.showNotificationPerfectionProgress){
                                this.showNotificationPerfectionProgress = false;
                            }
                            this.showNotificationPerfectionReset = true;
                            this.runAnimationsNotificationPerfectionReset();
                        }
                        else if(this.$store.state.perfectionData.type === 'achievement'){
                            this.showNotificationPerfectionAchievement = true;
                            this.runAnimationsNotificationPerfectionAchievement();
                        }
                    }

                    // Allow new requests.
                    this.allowRequest = true;
                })
                .catch(err => {
                    if(err instanceof Error){
                        console.error(`PRACTICE_PHONEMIC_CONSONANT_VIEW/CHECK_ANSWER_API::FETCH_ERROR`);
                        this.$foneturkError({
                            text: this.$t(`error.fetch`),
                        });
                    }
                    else if(err.code === 'CHECK_ANSWER_CONTROLLER/INDEX::INV_USER_SESSION'){
                        console.error(`PRACTICE_PHONEMIC_CONSONANT_VIEW/CHECK_ANSWER_API::API_ERROR_01 --> ${err.code}`);
                        this.$foneturkError({
                            text: this.$t(`error.api.checkAnswer.${err.code}`),
                            didClose: () => {
                                console.warn(`Routing to /login...`);
                                // this.$router.push('/login');
                            }
                        });
                    }
                    else if(this.$te(`error.api.checkAnswer.${err.code}`)){
                        console.error(`PRACTICE_PHONEMIC_CONSONANT_VIEW/CHECK_ANSWER_API::API_ERROR_02 --> ${err.code}`);
                        this.$foneturkError({
                            text: this.$t(`error.api.checkAnswer.${err.code}`),
                        });
                    }
                    else{
                        console.error(`PRACTICE_PHONEMIC_CONSONANT_VIEW/CHECK_ANSWER_API::UNEXPECTED_API_ERROR --> ${err.code}`);
                        this.$foneturkError({
                            text: this.$t(`error.fetch`),
                        });
                    }

                    this.allowRequest = true;
                });
            },

            skipAnswer(){
                // Get current question consonant features.
                let curQuestionConsonantFeatures = this.currentQuestion.consonantFeatures;

                // Update question correctness value.
                this.correctness = -1;

                // Update scorelist data prop.
                this.scorelist = [-1, -1, -1];

                // Update feedback data in vuex store.
                this.$store.commit('setFeedbackData', {
                    place: {
                        correctValue: curQuestionConsonantFeatures.place,
                        answerValue:  ''
                    },
                    manner: {
                        correctValue: curQuestionConsonantFeatures.manner,
                        answerValue:  ''
                    },
                    voicing: {
                        correctValue: curQuestionConsonantFeatures.voicing,
                        answerValue:  ''
                    }
                });

                // Update practice stats in vuex store.
                this.$store.commit('incrementPracticeStatSkipped');

                // Update the number of answered questions data prop.
                this.numAnswered++;

                // Activate feedback phase.
                this.feedbackPhase = true;

                // Play SFX.
                this.$store.state.sfx.skipped.currentTime = 0;
                this.$store.state.sfx.skipped.play();
            },

            skipAnswerApi(){

                // Check request allowance.
                if(this.allowRequest === false){
                    console.warn("PHONEMIC_CONSONANT_VIEW/SKIP_ANSWER_API::REQUEST_NOT_ALLOWED");
                    return;
                }
                this.allowRequest = false;

                // Prepare and send fetch request.
                fetch(this.$store.state.api.skipAnswer, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                .then(async response => {
                    // Check response status.
                    if(response.status !== 200){
                        throw await response.json();
                    }

                    // Parse response body $correctnessData.
                    return response.json();
                })
                .then(correctnessData => {
                    console.log(correctnessData);

                    // Update the number of answered questions.
                    this.numAnswered++;

                    // Update scorelist data.
                    this.scorelist = [-1, -1, -1];

                    // Update feedback data.
                    this.$store.commit('setFeedbackData', correctnessData.feedbackData);

                    // Update question correctness data.
                    this.correctness = correctnessData.correctness;

                    // Activate feedback phase.
                    this.feedbackPhase = true;

                    // Play SFX.
                    this.$store.state.sfx.skipped.currentTime = 0;
                    this.$store.state.sfx.skipped.play();

                    // Allow new requests.
                    this.allowRequest = true;
                })
                .catch(err => {
                    if(err instanceof Error){
                        console.error(`PRACTICE_PHONEMIC_CONSONANT_VIEW/SKIP_ANSWER_API::FETCH_ERROR`);
                        this.$foneturkError({
                            text: this.$t(`error.fetch`),
                        });
                    }
                    else if(err.code === 'SKIP_ANSWER_CONTROLLER/INDEX::INV_USER_SESSION'){
                        console.error(`PRACTICE_PHONEMIC_CONSONANT_VIEW/SKIP_ANSWER_API::API_ERROR_01 --> ${err.code}`);
                        this.$foneturkError({
                            text: this.$t(`error.api.skipAnswer.${err.code}`),
                            didClose: () => {
                                console.warn(`Routing to /login...`);
                                // this.$router.push('/login');
                            }
                        });
                    }
                    else if(this.$te(`error.api.skipAnswer.${err.code}`)){
                        console.error(`PRACTICE_PHONEMIC_CONSONANT_VIEW/SKIP_ANSWER_API::API_ERROR_02 --> ${err.code}`);
                        this.$foneturkError({
                            text: this.$t(`error.api.skipAnswer.${err.code}`),
                        });
                    }
                    else{
                        console.error(`PRACTICE_PHONEMIC_CONSONANT_VIEW/SKIP_ANSWER_API::UNEXPECTED_API_ERROR --> ${err.code}`);
                        this.$foneturkError({
                            text: this.$t(`error.fetch`),
                        });
                    }

                    this.allowRequest = true;
                });
            },

            nextQuestion(){
                // Check if current question was the last question; if so terminate practice session.
                let numQuestions   = this.$store.state.questionSet.length;
                let numCurQuestion = this.$store.state.practiceSession.idxCurQuestion + 1;

                if(numQuestions === numCurQuestion){
                    alert("Practice has been completed.");

                    // Check if this was a challenge practice.
                    if(this.$store.state.practiceSession.challengePractice){
                        this.$router.push('/challenge/results');
                    }
                    else{
                        this.$router.push('/practice-results');
                    }
                    return;
                }

                // Check if perfection achievement notification is shown; if so don't allow next question.
                if(this.showNotificationPerfectionAchievement){
                    return;
                }

                // Reset question correctness data prop.
                this.correctness = null;

                // Reset scorelist data prop.
                this.scorelist = [-1, -1, -1];

                // Reset answer data schema.
                let answerDataSchema = {
                    consonantFeatures: {
                        place:      null,
                        manner:     null,
                        voicing:    null
                    }
                }
                this.$store.commit('setAnswerDataSchema', answerDataSchema);

                // Deactivate feedback phase.
                this.feedbackPhase = false;

                // Reset feedback data.
                this.$store.commit('setFeedbackData', null);

                // Set next question as the current question.
                this.$store.commit('setNextQuestion');

                // Get the current question's place and manner features.
                let placeValue  = this.currentQuestion.consonantFeatures.place;
                let mannerValue = this.currentQuestion.consonantFeatures.manner;

                // Generate place and manner options for the new current question.
                let optionGenerator = new OptionGenerator();
                this.placeOptions  = optionGenerator.generatePlaceOptions(placeValue);
                this.mannerOptions = optionGenerator.generateMannerOptions(mannerValue);

                // Play animations.
                this.$nextTick(() => {
                    document.querySelector(".question-object-phonemic-consonant").classList.add('slide-in');
                    setTimeout(() => {
                        // @reason: I wrapped classlist removal in try catch because when a user quickly
                        // does skip-check and completes practice session, DOM can't find the question
                        // object element which causes a type error that it cannot read classList prop of null.
                        try{ document.querySelector(".question-object-phonemic-consonant").classList.remove('slide-in'); }
                        catch(error){ return; }
                    }, 500);
                });

                // Play next question vocalization after 500 ms.
                setTimeout(() => {
                    this.$store.state.sfx[this.vocalizationSlug].currentTime = 0;
                    this.$store.state.sfx[this.vocalizationSlug].play();
                }, 500);
            },

            nextQuestionApi(){

                // Check if perfection achievement notification is shown; if so don't allow next question.
                if(this.showNotificationPerfectionAchievement){
                    return;
                }

                // Check request allowance.
                if(this.allowRequest === false){
                    console.warn("PHONEMIC_CONSONANT_VIEW/NEXT_QUESTION_API::REQUEST_NOT_ALLOWED");
                    return;
                }
                this.allowRequest = false;

                // Prepare and send fetch request.
                fetch(this.$store.state.api.nextQuestion, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                .then(async response => {
                    // Check response status.
                    if(response.status !== 200){
                        throw await response.json();
                    }

                    // Parse response body $nextQuestionData
                    return response.json();
                })
                .then(nextQuestionData => {
                    console.log(nextQuestionData);

                    // Update practice stats.
                    this.$store.commit('setPracticeStats', nextQuestionData.stats);

                    // Check if practice session is completed.
                    if(nextQuestionData.completion === true){

                        // Check if this was a challenge practice.
                        if(this.$store.state.practiceSession.challengePractice){
                            this.$router.push('/challenge/results');
                        }
                        else{
                            this.$router.push('/practice-results');
                        }
                        return;
                    }

                    // Deactivate feedback phase.
                    this.feedbackPhase = false;

                    // Reset scorelist data.
                    this.scorelist = [-1, -1, -1];

                    // Reset feedback data.
                    this.$store.commit('setFeedbackData', null);

                    // Reset question correctness data.
                    this.correctness = null;

                    // Reset answer data schema.
                    let answerDataSchema = {
                        consonantFeatures: {
                            place:      null,
                            manner:     null,
                            voicing:    null
                        }
                    };
                    this.$store.commit('setAnswerDataSchema', answerDataSchema);

                    // Update current question index.
                    this.$store.commit('setIdxCurQuestion', nextQuestionData.idxCurQuestion);

                    // Get the current question's place and manner features.
                    let placeValue  = this.currentQuestion.consonantFeatures.place;
                    let mannerValue = this.currentQuestion.consonantFeatures.manner;

                    // Generate place and manner options for the new current question.
                    let optionGenerator = new OptionGenerator();
                    this.placeOptions  = optionGenerator.generatePlaceOptions(placeValue);
                    this.mannerOptions = optionGenerator.generateMannerOptions(mannerValue);

                    // Play animations.
                    this.$nextTick(() => {
                        document.querySelector(".question-object-phonemic-consonant").classList.add('slide-in');
                        setTimeout(() => {
                            // @reason: I wrapped classlist removal in try catch because when a user quickly
                            // does skip-check and completes practice session, DOM can't find the question
                            // object element which causes a type error that it cannot read classList prop of null.
                            try{ document.querySelector(".question-object-phonemic-consonant").classList.remove('slide-in'); }
                            catch(error){ return; }
                        }, 500);
                    });

                    // Play next question vocalization after 500 ms.
                    setTimeout(() => {
                        this.$store.state.sfx[this.vocalizationSlug].currentTime = 0;
                        this.$store.state.sfx[this.vocalizationSlug].play();
                    }, 500);

                    // Allow new requests.
                    this.allowRequest = true;
                })
                .catch(err => {
                    if(err instanceof Error){
                        console.error(`PRACTICE_PHONEMIC_CONSONANT_VIEW/NEXT_QUESTION_API::FETCH_ERROR`);
                        this.$foneturkError({
                            text: this.$t(`error.fetch`),
                        });
                    }
                    else if(err.code === 'NEXT_QUESTION_CONTROLLER/INDEX::INV_USER_SESSION'){
                        console.error(`PRACTICE_PHONEMIC_CONSONANT_VIEW/NEXT_QUESTION_API::API_ERROR_01 --> ${err.code}`);
                        this.$foneturkError({
                            text: this.$t(`error.api.nextQuestion.${err.code}`),
                            didClose: () => {
                                console.warn(`Routing to /login...`);
                                // this.$router.push('/login');
                            },
                        });
                    }
                    else if(this.$te(`error.api.nextQuestion.${err.code}`)){
                        console.error(`PRACTICE_PHONEMIC_CONSONANT_VIEW/NEXT_QUESTION_API::API_ERROR_02 --> ${err.code}`);
                        this.$foneturkError({
                            text: this.$t(`error.api.nextQuestion.${err.code}`),
                        });
                    }
                    else{
                        console.error(`PRACTICE_PHONEMIC_CONSONANT_VIEW/NEXT_QUESTION_API::UNEXPECTED_API_ERROR --> ${err.code}`);
                        this.$foneturkError({
                            text: this.$t(`error.fetch`),
                        });
                    }
                    
                    this.allowRequest = true;
                });
            },

            leavePractice(){
                // Disallow new requests.
                this.allowRequest = false;
            },

        },


        created(){
            // Set answer data schema.
            let answerDataSchema = {
                consonantFeatures: {
                    place:      null,
                    manner:     null,
                    voicing:    null
                }
            }
            this.$store.commit('setAnswerDataSchema', answerDataSchema);

            // Set fake api session data.
            let fakeApi = new FakeApi();
            // this.$store.commit('setPracticeSession', JSON.parse(fakeApi.practiceSessionPhonemicConsonant));
            // this.$store.commit('setQuestionSet', JSON.parse(fakeApi.questionSetPhonemicConsonantComplete));

            // Get first question's place and manner data for option generation.
            let placeValue  = this.currentQuestion.consonantFeatures.place;
            let mannerValue = this.currentQuestion.consonantFeatures.manner;

            // Generate place and manner options for the first question.
            let optionGenerator = new OptionGenerator();
            this.placeOptions = optionGenerator.generatePlaceOptions(placeValue);
            this.mannerOptions = optionGenerator.generateMannerOptions(mannerValue);
        },

        mounted(){
            // Play first question vocalization.
            this.$store.state.sfx[this.vocalizationSlug].currentTime = 0;
            this.$store.state.sfx[this.vocalizationSlug].play();

            // Set animation configurations.
            this.setAnimationsNotificationPerfectionProgress();
            this.setAnimationsNotificationPerfectionReset();
            this.setAnimationsNotificationPerfectionAchievement();
        },

        beforeUnmount(){
            this.revertAnimationsNotificationPerfectionProgress();
            this.revertAnimationsNotificationPerfectionReset();
            this.revertAnimationsNotificationPerfectionAchievement();
        }
    };
</script>

<style scoped src="@/css/views/view-practice-phonemic-consonant.css"></style>